export const USER_TOKEN = 'token';
export const USER_KEY = 'user';
export const FLOATING_THREADS = 'floatingThreads';
export const NAVBAR_COLLAPSED = 'navbar-collapsed';
